export default __webpack_public_path__ + "static/faq-656bccdbdab247e00cf08c658db77bb0.jpg";